import { WebBuilderPlatform } from '__generated__/types';

export const getPlatform = (platform: string) => {
    switch (platform) {
        case 'jimdo':
            return WebBuilderPlatform.JIMDO;
        case 'magento':
            return WebBuilderPlatform.MAGENTO;
        case 'shopify':
            return WebBuilderPlatform.SHOPIFY;
        case 'weebly':
            return WebBuilderPlatform.WEEBLY;
        case 'wix':
            return WebBuilderPlatform.WIX;
        case 'woocommerce':
            return WebBuilderPlatform.WOOCOMMERCE;
        case 'wordpress':
            return WebBuilderPlatform.WORDPRESS;
        case 'not_sure':
            return WebBuilderPlatform.NOT_SURE;
        default:
            throw `Unknown platform: ${platform}`;
    }
};
